//@flow
import React, { useState, useEffect, useRef } from 'react'
import Color from 'color';

import { CprTooltip } from 'canopy-styleguide!sofe'
import useClickToClose from 'src/custom-hooks/use-click-to-close'

import styles from './status-dropdown.styles.css'
import { clientRequestStatuses as clientRequestStatusesImported } from 'src/constants/client-request-status.constants';

type Props = {
  selectedStatus: string,
  onSelect: Function,
  style?: Object,
  width?: number,
  disabled: boolean,
}


export default function ClientRequestStatusDropdown(props: Props) {
  const clientRequestStatuses = clientRequestStatusesImported
  const dropdownRef = useRef()
  const [showStatus, setShowStatus] = useState(false)
  const [status, setStatus] = useState(clientRequestStatuses.WITH_CLIENT)

  useClickToClose(dropdownRef, () => setShowStatus(false))

  useEffect(() => {
    const effectStatus = clientRequestStatuses[props.selectedStatus] ? clientRequestStatuses[props.selectedStatus] : null
    if(effectStatus){
      setStatus(effectStatus)
    }
  }, [props.selectedStatus])

  const selectStatus = (option) => {
    setStatus(option)
    props.onSelect(option)
  }

  function lightenColor(color) {
    const newColor = darkenLoop(Color(color).lighten(0.8));
    return newColor.hex();
  }

  function darkenLoop(color) {
    if (color.lightness() > 95) return darkenLoop(color.darken(0.1));
    else return color;
  }

  const getStatusOptions = (statusOption) => {
    if(statusOption.value === clientRequestStatuses.NOSTATUS.value) return
    if(statusOption.value === clientRequestStatuses.DRAFT.value) return
    return (
    <div
      key={statusOption.value}
      onClick={e => selectStatus(statusOption)}
      data-test-class={`status-${statusOption.value}`}
      className={`${styles.status}`}
      style={statusOption.value === props.selectedStatus ? {background: lightenColor(statusOption.color)}: {}}
      >
        <div className={`${styles.statusInfo}`}>
          <CprTooltip html={statusOption.label} delayTime="500">
            <div
              style={{ background: statusOption.color }}
              className={`${styles.statusDot}`}
            />
          </CprTooltip>
          <div className="cps-ellipsis status-name">
            {statusOption.label}
          </div>
        </div>
    </div>
  )}

  const toggleDropdown = (e) => {
    setShowStatus(prevShow => !prevShow)
  }

  const disabledStatus = () => {
    return <div
      className={`${styles.statusRow} ${styles.nonClick}`}
      onMouseDown={e => e.stopPropagation()}
      style={{ width: `${props.width - 24}px` }}
      ref={dropdownRef}
    >
      <span>
        <div
          style={{ background: status.color }}
          className={`${styles.statusDot}`}
          title={status.label}
        />
      </span>
      <div className="cps-ellipsis">{status.label}</div>
    </div>
  }

  if(props.selectedStatus === clientRequestStatuses.NOSTATUS.value || props.selectedStatus === clientRequestStatuses.DRAFT.value || props.disabled){
    return disabledStatus()
  }

  return <>
    <div
      className={`${styles.clickTarget} ${styles.statusRow}`}
      onClick={e => toggleDropdown()}
      onMouseDown={e => e.stopPropagation()}
      style={{ maxWidth: `100%` }}
      ref={dropdownRef}
    >
      <span>
        <div
          style={{ background: status.color }}
          className={`${styles.statusDot}`}
          title={status.label}
        />
      </span>
      <div className="cps-ellipsis">{status.label}</div>
    </div>
    {showStatus &&
      <div
        className={`cps-card__height-2 ${styles.statusDropdown}`}
        style={{width: 250, ...props.style}}
      >
        <div
          className={`${styles.scrollBox}`}
        >
          {Object.keys(clientRequestStatuses).map(key => getStatusOptions(clientRequestStatuses[key]))}
        </div>
      </div>
    }
  </>
}